import { useState, useEffect, useContext } from 'react';

import { DataContext } from 'providers/data';
import { AdditionalServices } from 'core/productsTemplate';
import { ParamsProductServiceAdd } from 'utils/typeServices';

import Modals from 'components/views/Modals';
import { Box, Typography, Button } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as IcTakeArrowQuestions } from 'assets/icons/take-arrow-questions-icon.svg';

import { ContentCard, RiskGreen, ContentList, ButtonCustom, ButtonClosed } from './styles';

type ParamsListPackagesServices = {
    ListPackagesServices: Array<ParamsProductServiceAdd>;
    cdQuotation: number;
    listServicesAddTemplate: Array<ParamsProducTemplate>;
}

type ParamsProducTemplate = {
    NM_PRODUTO: string;
    CD_PRODUTO: number;
    NM_TITULO: string;
    DS_PRODUTO: Array<{
        DS_COBERTURA: Array<string>;
    }>;
}

const Card = ({ Product, cdQuotation }: { Product: ParamsProductServiceAdd; cdQuotation: number; }) => {
    const [isActive, setIsActive] = useState(false);
    const [addToCart, setAddToCart] = useState(false);
    const [showModalDetails, setShowModalDetails] = useState(false);
    const [productSelected, setProductSelected] = useState<ParamsProducTemplate>();
    const { selectedCar, dataProductCartAddServices, dataListActiveProducts, handleProductCartAddServices } = useContext(DataContext);

    const handleService = () => {
        if (selectedCar) {
            handleProductCartAddServices({
                bodyBase: {
                    cD_COTACAO: cdQuotation,
                    cD_PEDIDO: selectedCar.CD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                },
                body: {
                    cD_COTACAO_ITEM: Product.CD_COTACAO_ITEM,
                    cD_PRODUTO: Product.CD_PRODUTO,
                    nM_PRODUTO: Product.NM_PRODUTO,
                    nR_TIPO_PRODUTO: Product.NR_TIPO_PRODUTO,
                    nR_PORCENTAGEM_INDENIZACAO: Product.NR_PORCENTAGEM_INDENIZACAO,
                    vL_TOTAL: `R$ ${Product.VL_TOTAL?.split(' ')[1]}`
                },
                addProduct: !addToCart,
            });
        }
    }

    useEffect(() => {
        if (dataProductCartAddServices?.productAdd) {
            if (dataProductCartAddServices.productAdd?.findIndex(({ cD_PRODUTO }) => cD_PRODUTO === Product.CD_PRODUTO) > -1) {
                setAddToCart(true);
            } else {
                setAddToCart(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProductCartAddServices]);

    useEffect(() => {
        if (dataListActiveProducts) {
            if (dataListActiveProducts.find(({ CD_PRODUTO }) => CD_PRODUTO === Product.CD_PRODUTO)) {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListActiveProducts]);

    useEffect(() => {
        if (AdditionalServices?.find(({ CD_PRODUTO }) => CD_PRODUTO === Product.CD_PRODUTO)) {
            const selected = AdditionalServices?.find(({ CD_PRODUTO }) => CD_PRODUTO === Product.CD_PRODUTO);

            setProductSelected(selected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cdQuotation]);

    return (
        <Box>
            <ContentCard>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                        <Typography fontSize='1.125rem' fontWeight={700} lineHeight='26px' textTransform='uppercase' sx={{ maxWidth: { xs: 'auto', md: '8rem' } }}>
                            {Product.NM_PRODUTO.replace('Reparos -', '')}
                        </Typography>
                        <RiskGreen>
                            <div />
                            <span />
                        </RiskGreen>
                    </Box>

                    <Box sx={{ textAlign: 'center', display: { xs: 'block', md: 'none' } }}>
                        <Typography sx={{ fontSize: '.625rem', fontWeight: 300 }}>
                            Mensalidade
                        </Typography>
                        <Typography sx={{ fontSize: '1.5625rem', marginTop: '-1px', fontWeight: 700, color: 'primary.light' }}>
                            {Product.VL_TOTAL}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'auto 8rem', md: '1fr' }, gap: { xs: '.5rem', md: '0' }, marginTop: { xs: '.8rem', md: '0' } }}>
                    <ContentList>
                        {Product.DS_PRODUTO.map((value, index) => (
                            <li key={index}>
                                <Typography variant='body2' lineHeight='1.034rem' fontWeight={400}>
                                    + {value}
                                </Typography>
                            </li>
                        ))}
                    </ContentList>

                    <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', justifyContent: 'space-between' }}>
                        <Button
                            variant="text"
                            endIcon={<IcTakeArrowQuestions />}
                            disabled={productSelected ? false : true}
                            onClick={() => setShowModalDetails(true)}
                            sx={{ '&:hover': { backgroundColor: 'transparent' }, height: '1rem', marginTop: '.4rem', padding: '0', fontSize: '.75rem', fontWeight: 600, color: 'primary.light', 'svg': { width: '.8rem', margin: '0 0 .3rem -.1rem', transform: 'rotate(90deg)', filter: productSelected ? 'grayscale(0)' : 'grayscale(1)' } }}
                        >
                            SAIBA MAIS
                        </Button>

                        <ButtonCustom className={isActive ? 'contratado' : ''} variant='contained' handlebutton={addToCart ? 'remove' : 'add'} onClick={() => handleService()}>
                            {isActive ? 'CONTRATADO' : addToCart ? 'REMOVER' : 'ADICIONAR'}
                        </ButtonCustom>
                    </Box>
                </Box>

                <Button
                    variant="text"
                    endIcon={<IcTakeArrowQuestions />}
                    disabled={productSelected ? false : true}
                    onClick={() => setShowModalDetails(true)}
                    sx={{ '&:hover': { backgroundColor: 'transparent' }, height: '1rem', marginTop: '.4rem', padding: '0', fontSize: '.75rem', fontWeight: 600, color: 'primary.light', 'svg': { width: '.8rem', margin: '0 0 .3rem -.1rem', transform: 'rotate(90deg)', filter: productSelected ? 'grayscale(0)' : 'grayscale(1)' }, display: { xs: 'none', md: 'flex' } }}
                >
                    SAIBA MAIS
                </Button>

                <Box sx={{ textAlign: 'center', display: { xs: 'none', md: 'block' } }}>
                    <Typography sx={{ fontSize: '.625rem', fontWeight: 300, padding: '.8rem 0 .2rem' }}>
                        Mensalidade
                    </Typography>
                    <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700 }}>
                        {Product.VL_TOTAL}
                    </Typography>
                </Box>
            </ContentCard>

            <ButtonCustom className={isActive ? 'contratado' : ''} sx={{ display: { xs: 'none', md: 'block' } }} variant='contained' handlebutton={addToCart ? 'remove' : 'add'} onClick={() => handleService()}>
                {isActive ? 'CONTRATADO' : addToCart ? 'REMOVER' : 'ADICIONAR'}
            </ButtonCustom>

            <Modals open={showModalDetails}>
                <Box sx={{ padding: { xs: '3rem 1.5rem 1.8rem', md: '1.9rem 1.5rem 1.9rem 2.2rem' }, position: 'relative', width: { xs: 'calc(100vw - 2rem)', md: '43rem' }, overflow: 'hidden' }}>
                    <ButtonClosed onClick={() => setShowModalDetails(false)}>
                        <CloseIcon />
                    </ButtonClosed>

                    <Typography sx={{ fontSize: '1.25rem', marginBottom: '1rem', borderLeft: '4px solid #97C93D', padding: '.6rem 0 .3rem .8rem', fontWeight: 700 }}>
                        {Product.NM_PRODUTO.replace('Reparos -', '')}
                    </Typography>

                    <Box sx={{
                        position: 'relative',
                        maxHeight: { xs: '25rem', md: '30rem' },
                        overflowY: 'auto',
                        paddingRight: '.52rem',
                        '::-webkit-scrollbar': {
                            width: '.93rem',
                        },
                        '::-webkit-scrollbar-thumb': {
                            background: '#8D9BB5',
                            borderRadius: '.625rem'
                        }
                    }}>
                        <Box>
                            <Box sx={{ 'ul': { listStyleType: 'initial', paddingLeft: '1.5rem' }, 'li': { fontSize: '.875rem', paddingBottom: '.2rem', listStyleType: 'initial' } }}>
                                <Typography sx={{ fontSize: '.875rem', lineHeight: 1.3 }} dangerouslySetInnerHTML={{ __html: productSelected?.NM_TITULO || '' }} />
                            </Box>
                            <Typography sx={{ fontSize: '.875rem', color: 'primary.light', paddingTop: '.875rem' }}><b>Importante:</b></Typography>
                        </Box>

                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, paddingTop: '.5rem', gap: { xs: '.5rem', md: '1.5rem' }, justifyContent: 'space-between' }}>
                            {productSelected?.DS_PRODUTO.map(({ DS_COBERTURA }, index) =>
                                <Box key={index} sx={{ flex: '1', 'li': { fontSize: '.875rem' } }}>
                                    {DS_COBERTURA.map((value, index) =>
                                        <Typography key={index} sx={{ fontSize: '.875rem', lineHeight: 1.35, paddingBottom: '1rem' }} dangerouslySetInnerHTML={{ __html: value }} />
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ display: { xs: 'block', md: 'none' }, width: '100%', height: '1px', background: 'rgba(141, 155, 181, 0.40)', marginTop: '.9rem' }} />
                </Box>
            </Modals>
        </Box>
    )
}

const PackagesServices = ({ ListPackagesServices, cdQuotation, listServicesAddTemplate }: ParamsListPackagesServices) => {
    return (
        <Box sx={{ marginTop: '.43rem' }}>
            <Typography sx={{ fontSize: '1.25rem', marginBottom: '1rem', borderLeft: '4px solid #97C93D', padding: '.375rem 0 .275rem .8rem' }}>
                <b>Serviços completos</b> para a proteção do seu veículo
            </Typography>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: { xs: '1.3rem', md: '3.8%' }, justifyContent: 'space-between' }}>
                {ListPackagesServices.map((value, index) =>
                    <Card Product={value} cdQuotation={cdQuotation} key={index} />
                )}
            </Box>
        </Box>
    );
}

export default PackagesServices;